export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9520.028b0bb9.jpg";